<template>
  <HeaderContent title="Vendor" />
  <ActionContent
    ctaText="Add Vendor"
    @action="showModal"
    :filterDate="false"
    :filterModal="false"
    @search-query="searchData"
  />
  <VendorStatistics title="Vendor Statistics" :data="statistics" />
  <VendorForm
    :modal="modal"
    :vendorData="vendor"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />
  <VendorConfirm
    title="Confirmation"
    :uuid="vendorUuid"
    @confirmed="deleteData"
    v-model="modalConfirm"
  >
    <template #text>Are you sure to delete this data ?</template>
  </VendorConfirm>
  <VendorDataTable
    :data="vendors"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
</template>

<script>
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import VendorForm from "./VendorForm.vue";
import VendorDataTable from "@/components/DataTable.vue";
import VendorStatistics from "@/components/StatisticData.vue";
import VendorConfirm from "@/components/ModalDialog.vue";
import iconSeller from "../../../public/icons/seller.svg";
import { ref, inject, onMounted } from "vue";

export default {
  components: {
    HeaderContent,
    ActionContent,
    VendorForm,
    VendorDataTable,
    VendorStatistics,
    VendorConfirm,
  },
  setup() {
    const repositories = inject("repositories");
    const vendorRepository = repositories ? repositories.vendor : null;
    const modal = ref(false);
    const modalConfirm = ref(false);
    const vendorUuid = ref(null);
    const vendor = ref({});
    const vendors = ref([]);

    const headers = ref([
      {
        key: "no",
        label: "No",
        class: "text-left",
      },
      {
        key: "name",
        label: "Name",
        sortable: true,
        class: "text-left",
      },
      {
        key: "address",
        label: "Address",
        sortable: true,
        class: "text-left",
      },
      {
        key: "city",
        label: "City",
        sortable: true,
        class: "text-left",
      },
      {
        key: "phone",
        label: "Phone",
        sortable: true,
        class: "text-left",
      },
      {
        key: "email",
        label: "Email",
        sortable: true,
        class: "text-left",
      },
      {
        key: "description",
        label: "Description",
        sortable: true,
        class: "text-left",
      },
      {
        key: "pic_name",
        label: "PIC Name",
        sortable: true,
        class: "text-left",
      },
      {
        key: "pic_phone",
        label: "PIC Phone",
        sortable: true,
        class: "text-left",
      },
      {
        key: "pic_email",
        label: "PIC Email",
        sortable: true,
        class: "text-left",
      },
      {
        key: "status",
        label: "Status",
        sortable: true,
        class: "text-center",
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);

    const customActions = ref([
      {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
        },
      },
    ]);

    const statistics = ref([]);

    const getAll = async () => {
      await vendorRepository
        .getAll()
        .then((res) => {
          vendors.value = res.data.data;
          statistics.value = [
            {
              label: "Total",
              key: "Vendor",
              value: res.data.data.length,
              color: "primary",
              icon: iconSeller,
            },
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getById = async (uuid) => {
      await vendorRepository
        .getById(uuid)
        .then((res) => {
          vendor.value = res.data.data;
          modal.value = true;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const updateModal = (newValue) => {
      modal.value = newValue;
      vendor.value = {};
    };

    const showModal = () => {
      modal.value = true;
    };

    const showConfirmModal = (uuid) => {
      modalConfirm.value = true;
      vendorUuid.value = uuid;
    };

    const deleteData = async () => {
      await vendorRepository
        .delete(vendorUuid.value)
        .then(() => {
          modalConfirm.value = false;
          getAll();
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const searchData = async (keyword) => {
      await vendorRepository
        .search(keyword)
        .then((res) => {
          vendors.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    onMounted(() => {
      getAll();
    });

    return {
      modal,
      modalConfirm,
      vendorUuid,
      vendor,
      vendors,
      headers,
      customActions,
      statistics,
      updateModal,
      showModal,
      showConfirmModal,
      deleteData,
      getAll,
      getById,
      searchData,
    };
  },
};
</script>
